import { render, staticRenderFns } from "./ButtonSignout.vue?vue&type=template&id=0a3e02e6&"
import script from "./ButtonSignout.vue?vue&type=script&lang=js&"
export * from "./ButtonSignout.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSignout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports